/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_InventoryInputs */

const en_nav_inventory = /** @type {(inputs: Nav_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory`)
};

const es_nav_inventory = /** @type {(inputs: Nav_InventoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventario`)
};

/**
* | output |
* | --- |
* | "Inventory" |
*
* @param {Nav_InventoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_inventory = /** @type {((inputs?: Nav_InventoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_InventoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_inventory(inputs)
	return es_nav_inventory(inputs)
});